import Coureur from "@/classes/Coureurs/Coureur.class";
import List_Courses from "../Courses/List_Courses.class";
import List_Options from "../Options/List_Options.class";
import List_Activites from "../Activites/List_Activites.class";
import List_Articles_Boutique from "../Articles/List_Articles_Boutique.class";
import List_Packs_Courses from "../Packs_Courses/List_Packs_Courses.class";
import List_Champs_Formulaire from "../Champs_Formulaire/List_Champs_Formulaire.class";
import GIA from "../GIA/GIA.class";
import Donation from "../Donation/Donation.class";
import Code_Reduction from "../Code_Reduction/Code_Reduction.class";
import AlerteSMS from "../AlerteSMS/alerte_SMS.class";
import TeamPricingService from "@/services/booking/teamPricing.service";
import { useBookingStore } from "@/stores/bookingStore";

/**
 * @classdesc Une inscription
 * @kind class
 * @export
 * @prop {Courses} 
 * @prop {Coureur} coureur - Le coureur à inscrire
 * @prop {List_Courses} list_courses
 * @prop {List_Packs_Courses} list_packs_courses

 * 
 * @class MyClass
 */
export default class Inscription {
    coureur;
    list_courses;
    list_packs_courses;
    list_options;
    list_activites;
    list_articles;
    gia;
    alerte_sms;
    frais_bourse_dossard;
    donation;
    code_reduction;
    finished = false;
    lock_select_parcours = false;
    cart = { prix: 0, nb_articles: 0, type: [] };
    /**
     * Creates an instance of Inscription.
     * @constructs
     * @kind function
     * @memberof Inscription
     */
    constructor(id_module) {

        this.coureur = new Coureur();
        this.list_courses = new List_Courses(id_module);
        this.list_packs_courses = new List_Packs_Courses(id_module);
        this.list_options = new List_Options(id_module);
        this.list_activites = new List_Activites(id_module);
        this.list_articles = new List_Articles_Boutique(id_module);
        this.gia = new GIA(id_module);
        this.donation = new Donation(id_module);
        this.alerte_sms = new AlerteSMS(id_module);


    }

    setInscriptionFromLocalStorage(inscription, vip_ins = null, lien_groupe = null) {
        this.coureur.setFromStore(inscription.coureur, true);
        this.list_courses.set(inscription.list_courses.list);
        this.list_packs_courses.set(inscription.list_packs_courses.list);
        this.list_options.set(inscription.list_options.list);
        this.list_activites.set(inscription.list_activites.list);
        this.list_articles.set(inscription.list_articles.list);
        this.gia.set(inscription.gia);
        this.donation.set(inscription.donation);
        this.alerte_sms.set(inscription.alerte_sms);
        if (inscription.frais_bourse_dossard) {
            this.frais_bourse_dossard = inscription.frais_bourse_dossard;
        }
        // Restaurer le statut finished
        if (inscription.finished !== undefined) {
            this.finished = inscription.finished;
        }
        // Restaurer le statut lock_select_parcours
        if (inscription.lock_select_parcours !== undefined) {
            this.lock_select_parcours = inscription.lock_select_parcours;
        }
        this.update_all_carts(vip_ins, lien_groupe);
    }

    update_all_carts(vip_ins = null, lien_groupe = null) {
        this.update_cart("courses", vip_ins, lien_groupe);
        this.update_cart("packs_courses", vip_ins, lien_groupe);
        this.update_cart("options", vip_ins, lien_groupe);
        this.update_cart("activites", vip_ins, lien_groupe);
        this.update_cart("articles", vip_ins, lien_groupe);
        this.update_cart("gia", vip_ins, lien_groupe);
        this.update_cart("donation", vip_ins, lien_groupe);
        this.update_cart("alerte_sms", vip_ins, lien_groupe);
        if (this.frais_bourse_dossard) {
            this.update_cart("frais_bourse_dossard", vip_ins, lien_groupe);
        }
    }

    async set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                if (key == "coureur") {
                    this.coureur.setFromStore(value, true);
                }
                else if (key == "list_courses") {
                    this.list_courses.set(value.list);
                }
                else if (key == "list_packs_courses") {
                    this.list_packs_courses.set(value.list);
                }
                else if (key == "list_options") {
                    this.list_options.set(value.list);
                }
                else if (key == "list_activites") {
                    this.list_activites.set(value.list);
                }
                else if (key == "list_articles") {
                    this.list_articles.set(value.list);
                }
                else if (key == "gia") {
                    this.gia.set(value);
                }
                else if (key == "donation") {
                    this.donation.set(value);
                }
                else if (key == "code_reduction") {
                    if (value) {
                        this.code_reduction = new Code_Reduction();
                        this.code_reduction.set(value);
                    }

                }
                else if (key == "alerte_sms") {
                    this.alerte_sms.set(value);
                }

                else {
                    this[key] = value;
                }
            }
        }
        this.update_cart("packs_courses");
        this.update_cart("courses");
        this.update_cart("code_reduction")
        this.update_cart("options");
        this.update_cart("activites");
        this.update_cart("articles");
        this.update_cart("gia");
        this.update_cart("alerte_sms");
        if (this.frais_bourse_dossard) {
            this.update_cart("frais_bourse_dossard");
        }
    }
    valid_identity() {
        return this.coureur.validate();
    }

    refresh_tarifs(refreshed_tarifs) {
        for (let i = 0; i < this.list_courses.list.length; i++) {
            this.list_courses.list[i].refresh_tarifs(refreshed_tarifs);
        }
    }

    toggle_course_selection(index, inscription_plusieurs) {
        let result = this.list_courses.toggle_course_selection(index, inscription_plusieurs);
        let course = this.list_courses.list[index];
        if (course.is_equipe_course() && course.selected) {
            this.lock_select_parcours = true;
            // Décocher tous les autres parcours
            for (let i = 0; i < this.list_courses.list.length; i++) {
                if (i != index && this.list_courses.list[i].selected) {
                    this.list_courses.list[i].selected = false;
                }
            }
            // Décocher tous les packs sélectionnés et retirer leurs courses
            for (let i = 0; i < this.list_packs_courses.list.length; i++) {
                if (this.list_packs_courses.list[i].selected) {
                    this.list_packs_courses.list[i].selected = false;
                    this.list_courses.remove_course_from_pack(this.list_packs_courses.list[i]);
                }
            }
        } else if (course.is_equipe_course() && !course.selected) {
            // Si on décoche un parcours équipe, vérifier s'il reste d'autres parcours équipe sélectionnés
            const has_other_equipe_course_selected = this.list_courses.list.some(c =>
                c.id !== course.id && c.is_equipe_course() && c.selected
            );
            if (!has_other_equipe_course_selected) {
                this.lock_select_parcours = false;
            }
        }

        this.list_packs_courses.update_from_course_selection(this.list_courses.list);
        return result;
    }

    toggle_course_selection_from_dossard_bourse(dossard_bourse) {
        const id_course_dossard_bourse = dossard_bourse.course.id;
        if (!id_course_dossard_bourse) return false;

        const index_course_inscription = this.list_courses.list.findIndex((course) => course.id == id_course_dossard_bourse);

        if (index_course_inscription < 0) {
            return false;
        }
        let selected_course = this.list_courses.list[index_course_inscription];
        selected_course.selected = true;

        const vague_dossard_bourse = dossard_bourse.vague;
        const vagues_course = selected_course?.vagues?.list;
        if (vague_dossard_bourse && vagues_course) {
            const index_vague_inscription = vagues_course.findIndex((vague) => vague.nom == vague_dossard_bourse);
            if (index_vague_inscription >= 0) {
                vagues_course[index_vague_inscription].selected = true;
                selected_course.vague_selected = vagues_course[index_vague_inscription].id;
            }
        }
        this.toggle_course_selection(index_course_inscription, false);

        this.update_cart("courses", false);

    }

    toggle_pack_selection(index) {
        let result = { state: true, errors: [] };
        let pack = this.list_packs_courses.list[index];

        if (pack.selected) {

            for (let i = 0; i < this.list_packs_courses.list.length; i++) {
                if (this.list_packs_courses.list[i].id != pack.id) {
                    this.list_packs_courses.list[i].selected = false;
                    this.list_courses.remove_course_from_pack(this.list_packs_courses.list[i]);

                }
            }
            this.list_courses.add_course_from_pack(pack);
        }
        else {
            this.list_courses.remove_course_from_pack(pack);
        }
        return result;
    }

    get_courses() {
        return this.list_courses.list.filter(course => course.selected);
    }

    is_preinscription() {
        return this.list_courses.list.some(course => course.has_preinscriptions() && course.selected);
    }


    /**
     * Ajoute une course préselectionnée sur la homepage pour le premier coureur
     *
     * @param {*} id
     * @return {*} 
     * @memberof Inscription
     */
    add_course_from_preselection(id) {
        for (let i = 0; i < this.list_courses.list.length; i++) {
            let course = this.list_courses.list[i];
            if (course.id == id) {
                course.selected = true;
                if (course.is_equipe_course()) {
                    this.lock_select_parcours = true;
                }
                break;

            }
        }
        this.list_packs_courses.update_from_course_selection(this.list_courses.list);
    }
    /**
     * Ajoute un pack préselectionné sur la homepage pour le premier coureur
     *
     * @param {*} id
     * @return {*} 
     * @memberof Inscription
     */
    add_pack_from_preselection(id) {
        for (let i = 0; i < this.list_packs_courses.list.length; i++) {
            if (this.list_packs_courses.list[i].id == id) {
                let selection = this.list_packs_courses.list[i];
                selection.selected = true;
                this.list_courses.add_course_from_pack(selection);
                break;
            }
        }
    }

    get_all_tarifs_applied(nom_current_course) {
        let list_tarifs = [];
        const selected_courses = this.list_courses.get_selected();
        if (selected_courses.length == 0) return list_tarifs;
        for (let i = 0; i < selected_courses.length; i++) {
            const selected = selected_courses[i];
            if (nom_current_course && selected.nom == nom_current_course) continue;
            if (!selected.tarifs.list || !selected.cart) return list_tarifs;
            for (let i = 0; i < selected.tarifs.list.length; i++) {
                if (selected.tarifs.list[i].id == selected.cart.id_tarif) {
                    list_tarifs.push(selected.tarifs.list[i]);
                }
            }
        }
        return list_tarifs;
    }

    get_tarif_applied() {
        const selected_courses = this.list_courses.get_selected();
        if (selected_courses.length == 0) return null;
        const selected_course = selected_courses[0];

        if (!selected_course.tarifs.list || !selected_course.cart) return null;
        for (let i = 0; i < selected_course.tarifs.list.length; i++) {
            if (selected_course.tarifs.list[i].id == selected_course.cart.id_tarif) {
                return selected_course.tarifs.list[i];
            }
        }
        return null;
    }

    _getTeamPricingOptions() {
        const bookingStore = useBookingStore();
        const inscriptions = bookingStore.inscriptions || [];
        const inscriptionIndex = inscriptions.indexOf(this);
        if (inscriptionIndex < 0) {
            return null;
        }
        return {
            inscriptionIndex,
            leaderMap: TeamPricingService.buildLeaderMap(inscriptions),
            equipe_name: this.get_equipe_name(),
            teamPricingService: TeamPricingService,
        };
    }

    update_cart(type, vip_ins = null, lien_groupe = null) {
        switch (type) {

            case "courses":
                this.cart.type["courses"] = this.list_courses.update_cart(
                    this.list_packs_courses,
                    this.coureur,
                    vip_ins,
                    this,
                    lien_groupe,
                    this._getTeamPricingOptions()
                );
                break;
            case "packs_courses":
                this.cart.type["packs_courses"] = this.list_packs_courses.update_cart(lien_groupe);
                break;
            case "options":
                this.cart.type["options"] = this.list_options.update_cart(vip_ins, lien_groupe);
                break;
            case "activites":
                this.cart.type["activites"] = this.list_activites.update_cart(vip_ins, lien_groupe);
                break;
            case "articles":
                this.cart.type["articles"] = this.list_articles.update_cart(lien_groupe);
                break;
            case "gia":
                this.cart.type["gia"] = this.gia.update_cart();
                break;
            case "donation":
                this.cart.type["donation"] = this.donation.update_cart();
                break;
            case "code_reduction":
                this.cart.type["code_reduction"] = this.handle_code_reduction_cart();
                break;
            case "frais_bourse_dossard":
                this.cart.type["frais_bourse_dossard"] = this.frais_bourse_dossard;
                break;
            case "alerte_sms":
                this.cart.type["alerte_sms"] = this.alerte_sms.update_cart();
                break;

            default:
                break;
        }
        this.cart.type["code_reduction"] = this.handle_code_reduction_cart();


    }

    handle_code_reduction_cart() {
        if (this.code_reduction) {

            if (this.code_reduction.id == 194) {
                return this.code_reduction.update_cart_for_STLYON25(this.cart.type["courses"], this.list_courses.list);
            }
            if (this.code_reduction.id == 1042) {
                return this.code_reduction.update_cart_for_STLYON15(this.cart.type["courses"], this.list_courses.list);
            }

            if (this.code_reduction.id == 467) {
                return this.code_reduction.update_cart_for_LGCHER24(this.cart.type["courses"]);
            }
            if (this.code_reduction.id == 2444) {
                return this.code_reduction.update_cart_for_VVX26(this.cart.type["courses"], this.list_courses.list);
            }
            return this.code_reduction.update_cart(this.cart.type["courses"], this.cart.type["packs_courses"], this.cart.type["options"], this.cart.type["activites"]);
        }
        else {
            return { nb_articles: 0, prix: 0 };
        }

    }

    get_prix_course() {
        if (this.cart.type["courses"]) {
            return this.cart.type["courses"].prix;
        }
        return 0;
    }

    offer_bib() {
        this.code_reduction = new Code_Reduction();
        this.code_reduction.nom = "DOSSARD OFFERT";
        this.code_reduction.valeur = 100;
        this.update_cart("courses");
        this.update_cart("packs_courses");
        this.update_cart("code_reduction");

    }


    compute_cart() {
        this.cart.nb_articles = 0;
        this.cart.prix = 0;
        for (const [key, value] of Object.entries(this.cart.type)) {
            this.cart.nb_articles += parseInt(value.nb_articles);
            this.cart.prix += parseFloat(value.prix);
        }



        return this.cart;
    }
    /**
     * Propose le GIA si le prix des inscriptions course est supérieur à 10€ et que le module l'accepte
     *
     * @param {*} module_accept_gia
     * @memberof Inscription
     */
    initialize_gia(module_accept_gia) {
        if (!this.cart.type["courses"] || !this.cart.type["packs_courses"]) {
            this.gia.propose = false;
            this.gia.selected = false;
        }
        else {
            let prix_inscriptions = Math.max(this.cart.type["courses"].prix, this.cart.type["packs_courses"].prix);
            if (prix_inscriptions > 10 && module_accept_gia) {
                this.gia.propose = true;
            }
            else {
                this.gia.propose = false;
                this.gia.selected = false;
            }
        }
        this.set_prix_gia();
        this.update_cart("gia");
    }

    initialize_alerte_sms(has_alerte_sms) {

        if (has_alerte_sms) {
            this.alerte_sms.set_propose(true);
        }

        this.alerte_sms.set_selected(false);


        this.update_cart("alerte_sms");

    }

    initialize_frais_bourse_dossard() {

        this.frais_bourse_dossard = { prix: 5, nb_articles: 1 };
        this.update_cart("frais_bourse_dossard");

    }
    /**
     * Met à jour le prix du GIA en fonction du prix des inscriptions courses
     *
     * @memberof Inscription
     */
    set_prix_gia() {
        if (!this.cart.type["courses"] || !this.cart.type["packs_courses"]) {
            this.gia.set_prix(0);
        }
        else {
            let prix_inscriptions = Math.max(this.cart.type["courses"].prix, this.cart.type["packs_courses"].prix);
            this.gia.set_prix(prix_inscriptions);
        }

    }

    get_equipe_name() {
        if (this.coureur.equipe_name) {
            return this.coureur.equipe_name;
        }
        return "";
    }
    get_extra_fields_equipe() {
        if (this.coureur.extra_fields_equipe) {
            return this.coureur.extra_fields_equipe;
        }
        return {};
    }

    set_equipe_name(name) {
        this.coureur.equipe_name = name;
    }

    set_extra_equipe_fields(field) {

        if (field && field.name && field.value) {
            if (!this.coureur.extra_fields_equipe) {
                this.coureur.extra_fields_equipe = {};
            }
            this.coureur.extra_fields_equipe[field.name] = field.value;
        }
    }

    apply_code_reduction(code, vip_ins = null, lien_groupe = null) {
        this.code_reduction = code;
        this.update_cart("courses", vip_ins, lien_groupe);
        this.update_cart("packs_courses", vip_ins, lien_groupe);
        this.update_cart("options", vip_ins, lien_groupe);
        this.update_cart("activites", vip_ins, lien_groupe);
        this.update_cart("code_reduction");
        this.compute_cart();
    }

    async remove_code_reduction(vip_ins = null, lien_groupe = null) {
        await this.code_reduction.remove_usage();
        this.code_reduction = null;
        this.update_cart("courses", vip_ins, lien_groupe);
        this.update_cart("packs_courses", vip_ins, lien_groupe);
        this.update_cart("code_reduction");
        this.compute_cart();
    }
    /* ------------------------------------------------------- */

    /**
     * Sets the preselection based on the type of selection.
     * If the selection type is "course", it adds a course from the preselection.
     * If the selection type is "pack", it adds a pack from the preselection.
     *
     * @param {Object} selection - The selection object.
     * @param {string} selection.type - The type of the selection, either "course" or "pack".
     * @param {*} selection.value - The value of the selection to be added.
     */
    setPreselection(selection) {
        if (selection.type == "course") {
            this.add_course_from_preselection(selection.value);
        }
        if (selection.type == "pack") {
            this.add_pack_from_preselection(selection.value);
        }
    }

    /**
     * Handles the change of course for a given initial registration command.
     * 
     * This method removes the already reserved course and any team courses from the list of courses.
     * 
     * @param {Object} initial_commande_inscription - The initial registration command object.
     * @param {number} initial_commande_inscription.id_item - The ID of the item to be removed.
     */
    handle_changement_parcours(initial_commande_inscription) {
        if (!initial_commande_inscription) return;
        this.list_courses.remove_by_id(initial_commande_inscription.id_item); // On retire le parcours déjà réservé
        this.list_courses.remove_course_equipe(); // On retire les courses en équipe
    }


    /**
     * Checks if there are any courses in the list.
     *
     * @returns {boolean} True if there are courses in the list, otherwise false.
     */
    has_courses() {
        return this.list_courses.list.length > 0;
    }

    /**
     * Checks if there are any packs courses in the list.
     *
     * @returns {boolean} True if the list of packs courses is not empty, otherwise false.
     */
    has_packs_courses() {
        return this.list_packs_courses.list.length > 0;
    }

    /**
     * Generates the header information for a runner.
     *
     * @param {boolean} is_default_mode - Indicates if the default mode is active.
     * @param {boolean} is_billetterie_mode - Indicates if the billetterie mode is active.
     * @param {boolean} is_parcours_billetterie_mode - Indicates if the parcours billetterie mode is active.
     * @param {number} index - The index of the runner.
     * @returns {string} The header information for the runner.
     */
    get_entete_coureur(is_default_mode, is_billetterie_mode, is_parcours_billetterie_mode, index) {
        let entete = "";
        entete += this.get_nom_coureur(is_default_mode, index);
        entete += this.get_equipe_coureur();
        entete += this.get_parcours_coureur(is_billetterie_mode, is_parcours_billetterie_mode);
        return entete;
    }

    /**
     * Retrieves the name of the runner.
     *
     * @param {boolean} is_default_mode - Indicates if the default mode is active.
     * @param {number} index - The index of the runner.
     * @returns {string} The name of the runner if it has more than 2 characters, otherwise a default name based on the mode and index.
     */
    get_nom_coureur(is_default_mode, index) {
        let nom_coureur = this.coureur.get_nom();
        let num_coureur = index + 1;
        if (nom_coureur.length > 2) {
            return nom_coureur;
        }
        if (is_default_mode) {
            return "Coureur n°" + num_coureur;
        }
        return "Participant n°" + num_coureur;
    }

    get_vague_name() {
        const selected_course = this.list_courses.list.find((course) => course.selected);
        console.log(selected_course);
        const id_vague_selected = selected_course?.vague_selected;
        const vagues_course = selected_course?.vagues?.list;

        if (!vagues_course) return null;
        const selected_vague = vagues_course.find((vague) => vague.id == id_vague_selected);
        if (selected_vague) {
            return selected_vague.nom;
        }
        return null;
    }

    /**
     * Retrieves the team name of the runner if available.
     *
     * @returns {string} The team name of the runner formatted as ' ( Equipe <team_name> ) ' if it exists, otherwise an empty string.
     */
    get_equipe_coureur() {
        if (!this.coureur.equipe_name) return '';
        return this.coureur?.equipe_name != '' ? ' ( Equipe ' + this.coureur.equipe_name + ') ' : '';
    }

    /**
     * Retrieves the selected courses for a runner.
     *
     * @param {boolean} is_billetterie_mode - Indicates if the billetterie mode is active.
     * @param {boolean} is_parcours_billetterie_mode - Indicates if the parcours billetterie mode is active.
     * @returns {string} - A string representing the selected courses or an appropriate message.
     */
    get_parcours_coureur(is_billetterie_mode, is_parcours_billetterie_mode) {
        let parcours = "";
        if (is_billetterie_mode) {
            return "";
        }
        let selected_parcours = this.list_courses.list.filter(course => course.selected);

        parcours += selected_parcours.map(course => course.nom).join(" + ");
        if (is_parcours_billetterie_mode) return " - " + parcours;
        parcours = parcours != "" ? parcours : "Aucun parcours sélectionné";
        return " - Parcours: " + parcours;
    }

    /**
     * Retourne l'ID de la première course sélectionnée
     * @returns {number|null} L'ID de la course sélectionnée ou null si aucune course n'est sélectionnée
     */
    get_selected_course_id() {
        const selected_courses = this.get_courses();
        return selected_courses.length > 0 ? selected_courses[0].id : null;
    }

    /**
     * Initializes the form fields for the runner.
     *
     * @param {Object} champs_formulaire_store - The store containing the form fields.
     * @param {boolean} billetterie_mode - The mode indicating whether the ticketing system is active.
     */
    initialize_champs_coureur(champs_formulaire_store, billetterie_mode, hide_sexe_birthdate_fields = false) {
        let champs_formulaire = new List_Champs_Formulaire();
        champs_formulaire.id_module = this.id_module;
        champs_formulaire.list_ids_parcours = this.list_courses.get_selected_ids();

        champs_formulaire.set(champs_formulaire_store, billetterie_mode, hide_sexe_birthdate_fields);

        this.coureur.build_list_champs(champs_formulaire.list, this.list_courses);
    }

    /**
     * Sets the finished state of the reservation.
     *
     * @param {boolean} state - The state to set as finished.
     */
    set_finished(state) {
        this.finished = state;
    }


    /**
     * Filters available options based on selected courses and packs.
     * 
     * This method retrieves the selected courses and packs, then filters the available options accordingly.
     */
    filter_availables_options() {
        const selected_courses = this.list_courses.get_selected_courses();
        const selected_packs = this.list_packs_courses.get_selected_packs();
        this.list_options.filter_availables_options(selected_courses, selected_packs);
    }

    filter_availables_articles() {
        this.list_articles.filter_availables_articles();
    }

    getLyraSimplifiedData() {
        let inscription = {};
        inscription.cart = this.getSimplifiedCartData();
        const code_reductions_infos = this?.code_reduction?.getSimplifiedData();
        if (code_reductions_infos) inscription.code_reduction = code_reductions_infos;
        inscription.coureur = this.coureur.getSimplifiedData();
        const donation_infos = this.donation.getSimplifiedData();
        if (donation_infos) inscription.donation = donation_infos;
        const gia_infos = this?.GIA?.getSimplifiedData();
        if (gia_infos) inscription.gia = gia_infos;
        const activites_infos = this.list_activites.getSimplifiedData();
        if (activites_infos) inscription.activites = activites_infos;
        const options_infos = this.list_options.getSimplifiedData();
        if (options_infos) inscription.options = options_infos;
        const articles_infos = this.list_articles.getSimplifiedData();
        if (articles_infos) inscription.articles = articles_infos;
        const courses_infos = this.list_courses.getSimplifiedData();
        if (courses_infos) inscription.courses = courses_infos;
        const packs_infos = this.list_packs_courses.getSimplifiedData();
        if (packs_infos) inscription.packs_courses = packs_infos;
        return inscription;
    }

    getCheckAvailabilitiesData() {
        let data = {};
        const courses_infos = this.list_courses.getSimplifiedData();
        if (courses_infos) data.courses = courses_infos;
        const packs_infos = this.list_packs_courses.getSimplifiedData();
        if (packs_infos) data.packs_courses = packs_infos;
        const options_infos = this.list_options.getSimplifiedData();
        if (options_infos) data.options = options_infos;
        const activites_infos = this.list_activites.getSimplifiedData();
        if (activites_infos) data.activites = activites_infos;
        const articles_infos = this.list_articles.getSimplifiedData();
        if (articles_infos) data.articles = articles_infos;
        return data;
    }



    getSimplifiedCartData() {
        let cart = {};
        cart.prix = this?.cart?.prix;
        cart.nb_articles = this?.cart?.nb_articles;
        return cart;
    }












}